import type { SyncDomain } from './syncRuntime'

const REQUIRED_RESTORE_DOMAINS: SyncDomain[] = ['notes', 'settings', 'assets']

interface RestoreCycleEvidence {
  requestedDomains: SyncDomain[]
  notePullComplete: boolean
  settingsPullComplete: boolean
  assetPullComplete: boolean
}

export interface RestoreEvidenceResult {
  verifiedDomains: Set<SyncDomain>
  retryDomains: SyncDomain[]
  allDomainsVerified: boolean
}

export function applyRestoreCycleEvidence(
  currentVerifiedDomains: ReadonlySet<SyncDomain>,
  evidence: RestoreCycleEvidence,
): RestoreEvidenceResult {
  const verifiedDomains = new Set(currentVerifiedDomains)
  const retryDomains: SyncDomain[] = []

  for (const domain of evidence.requestedDomains) {
    const complete = domain === 'notes'
      ? evidence.notePullComplete
      : domain === 'settings'
        ? evidence.settingsPullComplete
        : domain === 'assets'
          ? evidence.assetPullComplete
          : true
    if (complete) verifiedDomains.add(domain)
    else retryDomains.push(domain)
  }

  return {
    verifiedDomains,
    retryDomains,
    allDomainsVerified: REQUIRED_RESTORE_DOMAINS.every(
      (domain) => verifiedDomains.has(domain),
    ),
  }
}
